import { authRoles } from 'app/auth';
import AsszociaciosKerdesTable from 'app/admin/asszociacioskerdes/table/AsszociaciosKerdesTable';
import AsszociaciosKerdesEditForm from 'app/admin/asszociacioskerdes/editform/AsszociaciosKerdesEditForm';

export default [
	{
		path: '/asszociacioskerdes/edit/:id',
		component: AsszociaciosKerdesEditForm,
		auth: authRoles.admin
	},
	{
		path: '/asszociacioskerdes/:sessionNameParam?',
		component: AsszociaciosKerdesTable,
		auth: authRoles.admin
	}
];
